import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FilterOption } from '../filters/filters.component';

@Component({
	selector: 'filters-dropdown',
	templateUrl: './filters-dropdown.component.html',
	styleUrls: ['./filters-dropdown.component.scss'],
})
export class FiltersDropdownComponent {
  @Input() savedFilters: any = {};
  @Input() selectedFilters: FilterOption[] = [];
  @Input() filterOptions: FilterOption[] = [];
  @Input() formGroup: UntypedFormGroup;
  @Output() applied: EventEmitter<FilterOption[]> = new EventEmitter();
  @Output() saved: EventEmitter<any> = new EventEmitter();
  json = JSON;

  constructor() { }
}